import { sensorTypesEnum } from "helpers/enums";

const dieselFuelLevelSensor = {
    searchKey: "",
    type: sensorTypesEnum.DieselFuelLevel,
};

const gasFuelLevelSensor = {
    searchKey: "",
    type: sensorTypesEnum.GasFuelLevel,
};

export { dieselFuelLevelSensor, gasFuelLevelSensor };
